import { createContext, useContext, useState, useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface CursorContextType {
  isLightCursor: boolean;
  setIsLightCursor: (value: boolean) => void;
}

const CursorContext = createContext<CursorContextType>({
  isLightCursor: false,
  setIsLightCursor: () => {},
});

export function CursorProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [isLightCursor, setIsLightCursor] = useState(location.pathname === "/contact");

  useEffect(() => {
    setIsLightCursor(location.pathname === "/contact");
  }, [location.pathname]);

  return (
    <CursorContext.Provider value={{ isLightCursor, setIsLightCursor }}>
      {children}
    </CursorContext.Provider>
  );
}

export const useCursor = () => useContext(CursorContext);
